import { fetchNewAccessToken } from "./ApiCallMethods";

// Access tokens expire after 30 minutes server-side; refresh a bit early so
// a normal request never actually hits a 401 in the middle of use.
const REFRESH_INTERVAL_MS = 25 * 60 * 1000;

let refreshTimerId = null;

export const startTokenRefresh = () => {
  if (refreshTimerId) return; // already running
  refreshTimerId = setInterval(() => {
    fetchNewAccessToken();
  }, REFRESH_INTERVAL_MS);
};

export const stopTokenRefresh = () => {
  if (refreshTimerId) {
    clearInterval(refreshTimerId);
    refreshTimerId = null;
  }
};
